import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import api from "../lib/api";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("autobahn_admin_token", r.data.token);
      localStorage.setItem("autobahn_admin_user", JSON.stringify(r.data.admin));
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#111111] text-white flex items-center justify-center px-6" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-block bg-white/5 p-4 rounded-sm">
            <Logo className="h-14 w-14" showWordmark invert />
          </div>
          <div className="mt-6 overline text-[#7A1519]">Admin Portal</div>
          <h1 className="mt-2 font-display text-3xl tracking-tight font-semibold">Sign in</h1>
        </div>

        <form onSubmit={submit} className="bg-white/5 border border-white/10 p-8 rounded-sm space-y-5">
          <div>
            <label className="overline text-white/50 block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-black/40 border border-white/10 px-4 py-3 rounded-sm text-sm outline-none focus:ring-1 focus:ring-[#7A1519]"
              data-testid="admin-login-email" autoComplete="username" />
          </div>
          <div>
            <label className="overline text-white/50 block mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-black/40 border border-white/10 px-4 py-3 rounded-sm text-sm outline-none focus:ring-1 focus:ring-[#7A1519]"
              data-testid="admin-login-password" autoComplete="current-password" />
          </div>
          <button type="submit" disabled={busy} className="w-full bg-[#7A1519] hover:bg-[#5a0f12] text-white py-3.5 rounded-sm text-sm font-semibold tracking-wide disabled:opacity-50" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-center pt-2">
            <Link to="/admin/forgot-password" className="text-xs text-white/60 hover:text-white underline underline-offset-4" data-testid="admin-forgot-link">
              Forgot password?
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
